import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=16c127d0&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=16c127d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c127d0",
  null
  
)

export default component.exports